// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
.supplier-profile-table .ant-descriptions-item-content {
    text-align: left;
}
}`, "",{"version":3,"sources":["webpack://./src/components/signup/SupplierProfile.css"],"names":[],"mappings":"AAAA;AACA;IACI,gBAAgB;AACpB;AACA","sourcesContent":["@media (max-width: 768px) {\n.supplier-profile-table .ant-descriptions-item-content {\n    text-align: left;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
